import { collection, doc, getDoc, getDocs, addDoc, updateDoc, deleteDoc, query, where, limit, Query, CollectionReference } from 'firebase/firestore';
import { db } from '../config/firebase';
import { ClientInfo } from '../models/ClientInfo';

const COLLECTION_NAME = 'clients';

export const addClient = async (client: Omit<ClientInfo, 'id'>): Promise<string> => {
    const docRef = await addDoc(collection(db, COLLECTION_NAME), {
        ...client,
        createdAt: new Date(),
        updatedAt: new Date()
    });
    return docRef.id;
};

export const getClient = async (id: string): Promise<ClientInfo | null> => {
    const docRef = doc(db, COLLECTION_NAME, id);
    const docSnap = await getDoc(docRef);
    
    if (!docSnap.exists()) {
        return null;
    }

    const data = docSnap.data();
    return {
        id: docSnap.id,
        ...data,
        createdAt: data.createdAt.toDate(),
        updatedAt: data.updatedAt.toDate(),
        billing: {
            ...data.billing,
            nextPaymentDate: data.billing?.nextPaymentDate?.toDate()
        }
    } as ClientInfo;
};

export const getAllClients = async (limitCount?: number): Promise<ClientInfo[]> => {
    let q: Query | CollectionReference = collection(db, COLLECTION_NAME);
    if (limitCount) {
        q = query(q, limit(limitCount));
    }
    
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        createdAt: doc.data().createdAt.toDate(),
        updatedAt: doc.data().updatedAt.toDate(),
        billing: {
            ...doc.data().billing,
            nextPaymentDate: doc.data().billing?.nextPaymentDate?.toDate()
        }
    })) as ClientInfo[];
};

export const updateClient = async (id: string, client: Partial<ClientInfo>): Promise<void> => {
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, {
        ...client,
        updatedAt: new Date()
    });
};

export const deleteClient = async (id: string): Promise<void> => {
    const docRef = doc(db, COLLECTION_NAME, id);
    await deleteDoc(docRef);
};

export const getClientsByCompanyName = async (companyName: string): Promise<ClientInfo[]> => {
    const q = query(
        collection(db, COLLECTION_NAME),
        where('companyName', '>=', companyName),
        where('companyName', '<=', companyName + '\uf8ff'),
        limit(10)
    );
    
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        createdAt: doc.data().createdAt.toDate(),
        updatedAt: doc.data().updatedAt.toDate(),
        billing: {
            ...doc.data().billing,
            nextPaymentDate: doc.data().billing?.nextPaymentDate?.toDate()
        }
    })) as ClientInfo[];
}; 